import { MakeCall } from 'ha/services/apiV2/createMakeCall';

export type RemoveSavedSearchCall = (
  userId: number,
  searchId: number,
) => Promise<{ data: {} }>;

export default (makeCall: MakeCall) => (userId: number, searchId: number) =>
  makeCall<undefined>('DELETE', `/api/v2/user/${userId}/search/${searchId}`);
